import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  Switch,
  Checkbox,
  IconButton,
} from "@mui/material";
import JWPlayer from "../../sharedComponents/JWPlayer/JWPlayer";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VideoJS from "../../sharedComponents/videoPlayer/VideoJS";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  statusHeader: {
    backgroundColor: "#6e8ccf",
  },
  btnApprove: {
    float: "right",
    color: "#ffffff",
  },
  courtSection: {
    border: "solid 1px #ccc",
    margin: theme.spacing(1),
    borderRadius: theme.spacing(0.75),
    minHeight: "100px",
  },
  sectionTitle: {
    paddingLeft: theme.spacing(1),
    color: "#d14360",
    fontWeight: 600,
  },
}));
export default function GameContentContainer(props) {
  const classes = useStyles();
  const token =
    "sp=racw&st=2021-11-03T17:29:08Z&se=2022-01-01T02:29:08Z&sv=2020-08-04&sr=c&sig=%2B1XiHqeyst13ToMCNOqNkKexo6tkb85%2BwCupMXZKdPc%3D";
  return (
    <Box component="div" className={classes.root}>
      <Box
        component="div"
        sx={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "center",
          backgroundColor: "#4d4b4d",
        }}
      >
        <div>
          <VideoJS
            fileURL={`${props.data.videoUrl}?${token}`}
            userName={props.data.playerName}
            playExternalVideo={true} //{props.data.playExternalVideo}
            fileName={props.data.videoUrl}
          />
        </div>
      </Box>
      <AppBar position="static" className={classes.statusHeader}>
        <Toolbar>
          <div style={{ display: "flex", flexGrow: 1 }}>
            <Typography variant="h6" noWrap component="div">
              {props.data.playerName ?? ""}
            </Typography>
            <Typography
              sx={{ paddingLeft: (theme) => theme.spacing(1) }}
              variant="h6"
              noWrap
              component="div"
            >
              {" "}
              |
            </Typography>
            <Typography
              sx={{ fontWeight: 300, paddingLeft: (theme) => theme.spacing(1) }}
              variant="h6"
              noWrap
              component="div"
            >
              {props.data.videoName ?? ""}
            </Typography>
          </div>
          <Button variant="text" className={classes.btnApprove}>
            {" "}
            APPROVE
          </Button>
        </Toolbar>
      </AppBar>
      <Box component="div" display="flex" flexGrow={1} p={2}>
        <Grid container sx={{ justifyContent: "center", flexWrap: "nowrap" }}>
          <Grid item md={3}>
            <Typography variant="body1" className={classes.sectionTitle}>
              Right Corner
            </Typography>
            <Grid className={classes.courtSection}>
              <RenderPlayShots shots={[1, 2, 3, 4, 5]} />
            </Grid>
          </Grid>
          <Grid item md={3}>
            <Typography variant="body1" className={classes.sectionTitle}>
              Right Elbow
            </Typography>
            <Grid className={classes.courtSection}>
              <RenderPlayShots shots={[6, 7, 8, 9, 10]} />
            </Grid>
          </Grid>
          <Grid item md={3}>
            <Typography variant="body1" className={classes.sectionTitle}>
              Top Key
            </Typography>
            <Grid className={classes.courtSection}>
              <RenderPlayShots shots={[11, 12, 13, 14, 15]} />
            </Grid>
          </Grid>
          <Grid item md={3}>
            <Typography variant="body1" className={classes.sectionTitle}>
              Left Elbow
            </Typography>
            <Grid className={classes.courtSection}>
              <RenderPlayShots shots={[16, 17, 18, 19, 20]} />
            </Grid>
          </Grid>
          <Grid item md={3}>
            <Typography variant="body1" className={classes.sectionTitle}>
              Left Corner
            </Typography>
            <Grid className={classes.courtSection}>
              <RenderPlayShots shots={[21, 22, 23, 24, 25]} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

const RenderPlayShots = ({ shots }) => {
  return (
    <List>
      <ListItem sx={{ justifyContent: "space-evenly" }}>
        <IconButton>
          <AddCircleOutlineIcon />
        </IconButton>
        <IconButton>
          <ArrowUpwardIcon />
        </IconButton>
        <IconButton>
          <ArrowDownwardIcon />
        </IconButton>
        <IconButton>
          <DeleteOutlineIcon />
        </IconButton>
      </ListItem>
      {shots.map((shot, index) => {
        return (
          <ListItem>
            <Checkbox />
            <ListItemText>{`Shot ${shot}`}</ListItemText>
            <Switch />
          </ListItem>
        );
      })}
    </List>
  );
};
